import React from 'react';

export default class CoverageRow extends React.Component {
  render() {
    const {RowData} = this.props
    return (
      <tr>
        <td>
          {RowData.City}
        </td>
        <td>
          {RowData.Province}   
        </td>
        <td>
          {RowData.Country}   
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/location/coverage/helper/component/CoverageRow.js